module.exports = __webpack_public_path__ + "img/右对齐.0cff809b.svg";